'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NavSubItem", {
    enumerable: true,
    get: function() {
        return NavSubItem;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useNavSubItem = require("./useNavSubItem");
const _renderNavSubItem = require("./renderNavSubItem");
const _useNavSubItemStylesstyles = require("./useNavSubItemStyles.styles");
const NavSubItem = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useNavSubItem.useNavSubItem_unstable)(props, ref);
    (0, _useNavSubItemStylesstyles.useNavSubItemStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useNavSubItemStyles_unstable')(state);
    return (0, _renderNavSubItem.renderNavSubItem_unstable)(state);
});
NavSubItem.displayName = 'NavSubItem';
